import ClientsIndex from 'views/Clients/ClientsIndex';
import Dashboard from 'views/Dashboard/Dashboard.jsx';
import QuotationsIndex from 'views/Quotations/QuotationsIndex';
import SalesIndex from 'views/Sales/SalesIndex';
import auth from '../libCustom/auth';
import ClientsForm from '../views/Clients/ClientsForm';
import QuotationsForm from '../views/Quotations/QuotationsForm';
import SalesForm from '../views/Sales/SalesForm';

auth.config({
  redirectLogin: '/#/admin',
  redirectNotLogin: '/#/iniciar-sesion',
  redirectNotAuthorization: '/#/notRole',
});

var dashboardRoutes = [
  {
    path: '/admin/dashboard',
    name: 'Inicio',
    icon: 'pe-7s-graph',
    component: Dashboard,
  },
  {
    path: '/admin/clients/:id',
    name: 'Clientes',
    component: ClientsForm,
    invisible: true,
  },
  {
    path: '/admin/clients',
    name: 'Clientes',
    icon: 'pe-7s-user',
    component: ClientsIndex,
  },
  {
    path: '/admin/quotations/:id',
    name: 'Cotizaciones',
    component: QuotationsForm,
    invisible: true,
  },
  {
    path: '/admin/quotations',
    name: 'Cotizaciones',
    icon: 'pe-7s-plane',
    component: QuotationsIndex,
  },
  {
    path: '/admin/sales/:id',
    name: 'Ordenes de Venta',
    component: SalesForm,
    invisible: true,
  },
  {
    path: '/admin/sales',
    name: 'Ordenes de Venta',
    icon: 'pe-7s-note',
    component: SalesIndex,
  },
];
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/basicRoutes.js